import React from "react";
import Nav from 'react-bootstrap/Nav';

import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";
import { Archive } from "lucide-react";
import ButtonNewDossier from "@app/components/2_widgets/dossiers/ButtonNewDossier";

/**
 * Tab navigation component to display different result sections
 * @param {Object} props - Component properties
 * @param {Array<{eventKey: string, tabTitle: string, title: string, subtitle: string}>} props.tabs - List of tabs to display
 * @param {Funtion} props.onTabChange - Callback function called when tab changes, received the selected eventKey as parameter
 * @param {Boolean} props.displayDossierTabs - Display the right tabs dedicated to the dossier management
 * @returns {JSX.Element} Bootstrap tab navigation with dynamically generated Nav.Items
 */
export default function Tabs({ tabs, onTabChange, activeTab, displayDossierTabs=false }) {    
    function displayIcon(tab) {
        if (tab.icon)
            return (tab.icon)
    }

    function displayRightTabs() {
        if (displayDossierTabs) {
            return (
                <div className="tab-buttons ms-auto">
                    <ButtonNewDossier reload={onTabChange} />
                </div>  
            )
        }
    }

    function displayTab(tab) {
        return (
            <Nav.Item key={tab.eventKey}>
                <Nav.Link eventKey={tab.eventKey}>
                    <span className="default-icon">{displayIcon(tab)}</span> 
                    {tab.tabTitle}
                </Nav.Link>
            </Nav.Item>           
        )
    }

    return (
        <div className="custom-tabs">
            <Nav 
                variant="tabs" 
                activeKey={activeTab}
                onSelect={onTabChange}
            >
                {tabs.map(displayTab)}
                {displayRightTabs()}                              
            </Nav>
        </div>
    );
}